export default __webpack_public_path__ + "fb2d7f132b724d4dd2d73cfa0187a7fe.png";